/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ServicesWizard {
    angular.module('meevo.plugins.servicesWizard', []);
}